import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import { useAppSelector } from "../../../../../store/hooks/StoreHooks";
import EfficiencyCurve from "./EfficiencyCurve";
import { createChart1 } from "../../../../../utilities/commonUtilities";

interface Props { }

const EfficiencyCurves: React.FC<Props> = () => {
  const { Chart1Data } = useAppSelector((state) => state?.pump);
  const { isReports } = useAppSelector((state) => state?.reports);
  const efficiencyChartRef = useRef<HTMLDivElement | null>(null);
  const [chart1Config, setChart1Config] = useState<any>([]);

  useEffect(() => {
    if (Chart1Data) {
      setChart1Config(createChart1(Chart1Data));
    }
  }, [Chart1Data]);

  const efficiencyChartDownload = () => {
    if (efficiencyChartRef.current) {
      html2canvas(efficiencyChartRef.current, {
        backgroundColor: "#384252",
      }).then((canvas) => {
        const imgUrl = canvas.toDataURL("image/png");

        const link = document.createElement("a");
        link.href = imgUrl;
        link.download = "Efficiency-Curves.png";
        link.click();
      });
    }
  };

  return (
    <>
      {" "}
      <div className="flex justify-between mt-[16px] p-4">
        <div></div>
        {!isReports && <div className="flex">
          <button
            onClick={efficiencyChartDownload}
            className="ml-[16px] border-[1px] border-solid border-[#4A5463] py-[8px] px-[14px] inline-flex justify-center items-center gap-[8px] rounded-[8px] bg-transparent text-neutral-25"
          >
            Export efficiency curve
          </button>
        </div>}
      </div>
      <div className="mb-[15px] pt-[30px]" ref={efficiencyChartRef}>
        <EfficiencyCurve chart1Data={chart1Config} />
      </div>
    </>
  );
};

export default EfficiencyCurves;
